/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserProfileResponse } from '../models/UserProfileResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
    /**
     * Get current user profile
     * Get user profile for display in UI (includes personal contact info)
     * @param userSession
     * @returns UserProfileResponse Successful Response
     * @throws ApiError
     */
    public static getCurrentUserProfile(
        userSession?: (string | null),
    ): CancelablePromise<UserProfileResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/me',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
